module.exports = __webpack_public_path__ + "static/social-3e59787ecf591ba5c386fc76034d34b0.jpg";